/* globals Front */
(function($) {
	'use strict';
	$.fn.Slide__CommentsTrigger = function() {
		this.each(function() {

			/*
			 * Action: Open comments dialog
			 */
			const selector = '[data-controller="Slide__CommentsTrigger"]';
			$.Document.off( $.Globals.clickEvent, selector ).on( $.Globals.clickEvent, selector, function(e) {
				e.preventDefault();

				const $self = $(this);

				// If we clicked one thats already opened, close then don't continue
				if( $self.hasClass('active') ) {

					// Remove the popups
					$('body > .popup').remove();
					$self.removeClass('active');

					// Stop
					return;

				}

				// Close any other existing popups
				$.Globals.closePopups();

				const collection_id = $self.data('cid'), // <= this is cached (always on the same collection so it doesn't matter)
					slide_id = parseInt( $self.attr('data-sid'), 10 ),
					slide_data = $.Globals.getCollectionSlideById( collection_id, slide_id ),

					// Get options
					popup = $('#slide__comments').html(),
					render_obj = {
						collection_id: collection_id,
						slide_id: slide_id,
					},
					offset = $self.offset();



				// Set the offset
				render_obj.offset = {
					bottom: $.Window.height() - offset.top + 18, // <= 18 is offset from $self
					right: $.Window.width() - offset.left - $self.width(),
				};

        // Get comments
				render_obj.comments = slide_data.comments;
				console.log(slide_data.comments);

				// Parse it
				Mustache.parse( popup );
				const output = Mustache.render( popup, render_obj );


				// Add it to dom and fade it in
				$.Body.append( output );

				// Activate trigger
				$self.addClass('active');

				setTimeout( function() {

					// Listen for global closes
					$.Globals.listenForGlobalClosePopup();

					// All setup, instantiate new controllers
					$('.popup[data-controller]').each( function() {
						$(this).Instantiate();
					});

				}, 1 );


			});


		});
		return this;
	};
}(jQuery));
